// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"7ef04aa9","937":"91e979f1","945":"e58e4727"}[chunkId] + ".chunk.js";
};